export default __webpack_public_path__ + "static/media/share-dark.642ad02e.svg";